import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Map/SearchResults/index.js",
  _this = this;
import React, { createRef, useEffect, useRef, useState } from 'react';
import FilterIcon from '@dls/assets/icons/Filter';
import { ArrowUp, ArrowDown } from '@dls/assets/icons';
import { useTheme } from '../../../core/ThemeProvider';
import Text from '../../Text';
import Spacing from '../../Spacing';
import Selector from '../../Selector';
import TextLink from '../../TextLink';
import { getDistanceInKmFormattedValue } from '../helpers';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { StyledArrowIconContainer, StyledFilterContainer, StyledFilterIconContainer, StyledSearchResultsHeading, StyledViewMoreLessLinkContainer, StyledInitialResultSelectorContainer } from './styles';
import { slideAnimationDurationInMillis } from '../config';
import { getLocationSelectorsTransitionStartYPosition, getViewLessLinkTransitionStartYPosition } from './helpers';
import { SlideAnimation } from './animation';
var SearchResults = function SearchResults(_ref) {
  var renderHeading = _ref.renderHeading,
    showFilter = _ref.showFilter,
    onFilterClick = _ref.onFilterClick,
    locations = _ref.locations,
    onLocationSelected = _ref.onLocationSelected,
    viewMoreLabel = _ref.viewMoreLabel,
    viewLessLabel = _ref.viewLessLabel,
    initialSearchResultCount = _ref.initialSearchResultCount;
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMoreLocations = _useState2[0],
    setShowMoreLocations = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showViewMoreLabel = _useState4[0],
    setShowViewMoreLabel = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    locationsList = _useState6[0],
    setLocationsList = _useState6[1];
  var viewLessLinkNodeRef = useRef(null);
  var moreLocationsAvailable = locations.length > initialSearchResultCount;
  useEffect(function () {
    var resultSet = locations.map(function (location) {
      var ref = /*#__PURE__*/createRef();
      return Object.assign({}, location, {
        nodeRef: ref
      });
    });
    setLocationsList(resultSet);
  }, [locations]);
  var renderLocationSelector = function renderLocationSelector(location, index) {
    var formattedDistance = " (".concat(getDistanceInKmFormattedValue(location.distance, 'KM'), ")") || '';
    var title = "".concat(location.name).concat(formattedDistance);
    return /*#__PURE__*/React.createElement(Spacing, {
      top: 2,
      responsive: false,
      key: location.name,
      index: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Selector, {
      alignment: "row",
      selected: location.isSelected,
      onClick: function onClick() {
        onLocationSelected(index);
      },
      "data-testid": "location-selector",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Selector.Body, {
      title: title,
      align: 'start',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 11
      }
    }, location.descriptionLiner && /*#__PURE__*/React.createElement(Text, {
      type: "smallBody",
      color: theme.cl_ter_l2,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 15
      }
    }, location.descriptionLiner))));
  };
  var renderInitialResultSet = function renderInitialResultSet() {
    return locationsList.slice(0, initialSearchResultCount).map(function (location, index) {
      return /*#__PURE__*/React.createElement(StyledInitialResultSelectorContainer, {
        key: location.name,
        ref: location.nodeRef,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 11
        }
      }, renderLocationSelector(location, index));
    });
  };
  var getMoreLocationSelectorsTransitions = function getMoreLocationSelectorsTransitions(moreLocations, animationDuration) {
    return moreLocations.map(function (location, index) {
      return /*#__PURE__*/React.createElement(CSSTransition, {
        timeout: animationDuration,
        key: location.name,
        nodeRef: location.nodeRef,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103,
          columnNumber: 9
        }
      }, function (transitionState) {
        var translateYPos = getLocationSelectorsTransitionStartYPosition(locationsList, location.nodeRef, initialSearchResultCount);
        return /*#__PURE__*/React.createElement(SlideAnimation, {
          transitionState: transitionState,
          animationDuration: animationDuration,
          translateYPos: translateYPos,
          ref: location.nodeRef,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116,
            columnNumber: 15
          }
        }, renderLocationSelector(location, index + initialSearchResultCount));
      });
    });
  };
  var getViewLessLinkTransition = function getViewLessLinkTransition(animationDuration) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      timeout: animationDuration,
      key: 'viewLessLink',
      onExited: function onExited() {
        setShowViewMoreLabel(true);
      },
      nodeRef: viewLessLinkNodeRef,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 136,
        columnNumber: 7
      }
    }, function (transitionState) {
      var translateYPos = getViewLessLinkTransitionStartYPosition(locationsList, viewLessLinkNodeRef, initialSearchResultCount);
      return /*#__PURE__*/React.createElement(SlideAnimation, {
        transitionState: transitionState,
        animationDuration: animationDuration,
        translateYPos: translateYPos,
        ref: viewLessLinkNodeRef,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 152,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(StyledViewMoreLessLinkContainer, {
        onClick: function onClick() {
          setShowMoreLocations(false);
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(TextLink, {
        "data-testid": "view-less-label",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 163,
          columnNumber: 17
        }
      }, viewLessLabel), /*#__PURE__*/React.createElement(StyledArrowIconContainer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(ArrowUp, {
        color: theme.cl_sec_d1,
        size: 16,
        "data-testid": "arrow-up",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167,
          columnNumber: 19
        }
      }))));
    });
  };
  var renderViewMoreResultSet = function renderViewMoreResultSet() {
    var transitionsList = [];
    if (showMoreLocations) {
      var moreLocations = locationsList.slice(initialSearchResultCount);
      transitionsList = getMoreLocationSelectorsTransitions(moreLocations, slideAnimationDurationInMillis);
      if (moreLocationsAvailable) {
        var viewLessLinkTransition = getViewLessLinkTransition(slideAnimationDurationInMillis);
        transitionsList.push(viewLessLinkTransition);
      }
    }
    return /*#__PURE__*/React.createElement(TransitionGroup, {
      appear: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 12
      }
    }, transitionsList);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacing, {
    top: 2,
    responsive: false,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 205,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(StyledFilterContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 206,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(StyledSearchResultsHeading, {
    type: "boldBody",
    "data-testid": "search-results-heading",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 11
    }
  }, typeof renderHeading === 'function' && renderHeading()), showFilter && /*#__PURE__*/React.createElement(StyledFilterIconContainer, {
    onClick: onFilterClick,
    "data-testid": "filter-icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FilterIcon, {
    color: theme.cl_sec_d1,
    size: 24,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 15
    }
  })))), renderInitialResultSet(), renderViewMoreResultSet(), moreLocationsAvailable && showViewMoreLabel && /*#__PURE__*/React.createElement(StyledViewMoreLessLinkContainer, {
    onClick: function onClick() {
      setShowMoreLocations(true);
      setShowViewMoreLabel(false);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 229,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(TextLink, {
    "data-testid": "view-more-label",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 235,
      columnNumber: 11
    }
  }, viewMoreLabel), /*#__PURE__*/React.createElement(StyledArrowIconContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 236,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ArrowDown, {
    color: theme.cl_sec_d1,
    size: 16,
    "data-testid": "arrow-down",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 237,
      columnNumber: 13
    }
  }))));
};
export default SearchResults;